import React from "react";
import {Skeleton} from "@material-ui/lab";
import {SKELETON_HEIGHT} from "../helpers/SkeletonHelper";

const CustomSkeleton = (props) => {
    const {
        width,

        ...others
    } = props;
    return (
        <Skeleton animation='wave' height={SKELETON_HEIGHT} width={width || '80%'}
                  {...others}
                  style={{marginBottom: 6}}
            />
    )
}
export default CustomSkeleton;
